import { render } from "./SubsectionNavBottom.vue?vue&type=template&id=8734f468"
import script from "./SubsectionNavBottom.vue?vue&type=script&lang=js"
export * from "./SubsectionNavBottom.vue?vue&type=script&lang=js"

import "./SubsectionNavBottom.vue?vue&type=style&index=0&id=8734f468&lang=scss"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__